import { DataBelanjaDiToko } from "../../data/DataBelanjaDiToko";

export const BelanjaDiTokoUDJ = () => {
  return (
    <div className="udj-info-wrapper">
      <p className="belanja-di-toko-subtitle">
        Cari tahu limit pembiayaanmu sebelum ajukan cicilan untuk barang impian.
      </p>
      <p className="udj-title">Ikuti langkah mudah pengajuannya</p>
      <div className="udj-wrapper">
        {DataBelanjaDiToko.map((data, key) => {
          return (
            <div className="udj-container" key={key}>
              <img src={data.img}></img>
              <p className="udj-description">{data.desc}</p>
            </div>
          );
        })}
      </div>
      <p className="udj-title">Tinggal bawa barang impian deh!</p>
      <style jsx>{`
        .udj-wrapper {
          display: flex;
          justify-content: center;
        }
        .udj-container {
          margin-right: 20px;
          display: flex;
          flex-direction: column;
        }
        .udj-description {
          font-size: 16px;
          max-width: 140px;
        }
        .udj-title {
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 32px;
          margin-top: 48px;
        }
        .belanja-di-toko-subtitle {
          font-size: 16px;
          text-align: center;
        }
        @media only screen and (max-width: 950px) {
          .udj-wrapper {
            flex-wrap: wrap;
          }
        }
        @media only screen and (max-width: 600px) {
          .udj-wrapper {
            flex-direction: column;
          }
          .udj-container {
            flex-direction: row;
            align-items: center;
            margin: 0px 16px 0px 24px;
          }
          .udj-title {
            margin: 32px 16px 24px;
            font-size: 16px;
          }
          .udj-description {
            font-size: 14px;
            margin: 16px;
            max-width: 100%;
          }
          .udj-container img {
            width: 64px;
            height: 64px;
          }
          .belanja-di-toko-subtitle {
            font-size: 12px;
            margin: 16px;
          }
        }
      `}</style>
    </div>
  );
};
